import { observer } from 'mobx-react';
import { useStore } from '../../../state/MobxContext';
import Box from '@mui/material/Box';
import { Button } from '@mui/material';
// import Dialog from '@mui/material/Dialog';
// import CloverleafImage from '../../Main/image/Cloverleaf.png';
// import DialogContent from '@mui/material/DialogContent';
// import { TextField } from '@mui/material';
import {  useMediaQuery } from "@material-ui/core";
import { Typography } from "@material-ui/core";
// import { withStyles } from "@material-ui/core/styles";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faXmark } from '@fortawesome/free-solid-svg-icons';
import Grid from "@mui/material/Grid/Grid";
// import { toJS } from 'mobx';
import { TextField } from '@mui/material';
import InputAdornment from "@mui/material/InputAdornment";
import { faCopy } from '@fortawesome/free-regular-svg-icons';

// import Slider from 'react-slick';
// import CloverMarketCategoryBar from './CloverMarketCategoryBar';
import "../../../../node_modules/slick-carousel/slick/slick.css"
import "../../../../node_modules/slick-carousel/slick/slick-theme.css"
// import MarketCategoryCard from './MarketCategoryCard';
// import styled from "@emotion/styled";
// import ProductCard from './ProductCard';













function ExchangePage() {
  const { loginStore } = useStore();
  // const { SaleStore } = useStore();
  const { CoinExchangeStore } = useStore();
  // const { CoinStore } = useStore();


  // const navigate = useNavigate();

  // const useStyles = makeStyles((theme) => ({
  //   //Dialog
  //   Dialog: {
  //     width: '500px',
  //     height: "460px",
  //     // minHeight: "25rem",
  //     minHeight: "auto",
  //     // backgroundColor:"#212121"

  //   },
  //   DialogMobile: {
  //     height: '100%',
  //     width: '100%',
  //     minWidth: "320px",
  //     padding: '0'
  //   },
  //   //CategoryImage
  //   CategoryImage: {
  //     whiteSpace: "nowrap",
  //     objectFit: "cover",
  //     width: '10rem',
  //     height: "5rem"
  //   },
  //   //CategoryImage
  //   BrandImage: {
  //     whiteSpace: "nowrap",
  //     objectFit: "cover",
  //     width: '12rem',
  //     height: "12rem"
  //   },
  //   //BrandiamgeSlide
  //   BrandiamgeSlide: {
  //     dots: true,
  //     infinite: true,
  //     speed: 500,
  //     slidesToShow: 1,
  //     slidesToScroll: 1
  //   }
  // }));


  // const classes = useStyles();
  const isMobile = useMediaQuery("(max-width: 600px)");

  // let Clover_sale_count = SaleStore?.sale_clover_Token;

  // let User_Clover_Count = loginStore.CloverCount;
  let ErrorGuide_clover_page_userBar_01 = loginStore?.ErrorGuide_clover_page_userBar_01; //복사에 실패하였습니다
  // let Guide_clover_page_userBar_01 = loginStore?.Guide_clover_page_userBar_01; //복사 하였습니다
  let Guide_clover_dialog_ExchangePage_01 = loginStore?.Guide_clover_dialog_ExchangePage_01; //플레타
  let Guide_clover_dialog_ExchangePage_02 = loginStore?.Guide_clover_dialog_ExchangePage_02; //엘뱅크-TRC20
  let Guide_clover_dialog_ExchangePage_03 = loginStore?.Guide_clover_dialog_ExchangePage_03; //은행
  let Guide_clover_dialog_ExchangePage_04 = loginStore?.Guide_clover_dialog_ExchangePage_04; //계좌번호
  let Guide_clover_dialog_ExchangePage_05 = loginStore?.Guide_clover_dialog_ExchangePage_05; //전송
  let Guide_clover_dialog_ExchangePage_06 = loginStore?.Guide_clover_dialog_ExchangePage_06; //취소
  let Guide_clover_dialog_Mining_13 = loginStore?.Guide_clover_dialog_Mining_13; //수량






  const BTCaddress = "TR6q3ABoZ3DQL8WJDjGn39JDLLRfnmFVWm";
  const USDTaddress = "1HVU9GYtY73FAWJiex7qshXLX3PuSZSEyp";


  let isBTC = CoinExchangeStore?.isBTCOpen;
  let isUSTD = CoinExchangeStore?.isUSTDOpen;

  let userID = CoinExchangeStore?.userID;
  let userName = CoinExchangeStore?.userName;
  let userCountBTC = CoinExchangeStore?.userCountBTC;
  let userAddress = CoinExchangeStore?.userAddress;
  let userBank = CoinExchangeStore?.userBank;



  // this.userID = "";
  // userName = "";
  // userCountBTC = "";
  // userAddress = "";
  // userBank = "";


  // console.log(CategoryTable);
  // console.log(BrandChack);


  const copy = async (text) => {
    // console.log(text);
    if (text === undefined || text === null || text === "") {
      return alert(ErrorGuide_clover_page_userBar_01);
    }
    else {
      try {
        await navigator.clipboard.writeText(text);
        if (isBTC === true) {
          window.open("https://mobile.flata.exchange/trade");
        }
        else if (isUSTD === true) {
          window.open("https://www.lbank.com");
        }
        // return alert(Guide_clover_page_userBar_01);
      } catch (error) {
        // console.log(error);
        return alert(ErrorGuide_clover_page_userBar_01);
      }
    }
  };

  const TextData = async (Data, text) => {
    // console.log("GOOD", Data, text);
    if (Data === "ID") {
      CoinExchangeStore.getUserID(text);
    }
    else if (Data === "Name") {
      CoinExchangeStore.getUserName(text);
    }
    else if (Data === "BTC") {
      CoinExchangeStore.getUserBTC(text);
    }
    else if (Data === "계좌번호") {
      CoinExchangeStore.getUserAddress(text);
    }
    else if (Data === "은행") {
      CoinExchangeStore.getUserBank(text);
    }
  }

  const ButtonData = (value) => {
    CoinExchangeStore?.setExchangeData(value);
  }


  const WalletTextField = ({ iconStart, iconEnd, InputProps, ...props }) => {
    return (
      <TextField
        fullWidth
        variant="standard"
        {...props}
        inputProps={isMobile ? { min: 0, style: { textAlign: 'center', fontSize: 7.7 } } : { min: 0, style: { textAlign: 'center', fontSize: 14, } }}
        InputProps={{
          ...InputProps,
          startAdornment: iconStart ? (
            <InputAdornment position="start">{iconStart}</InputAdornment>
          ) : null,
          endAdornment: iconEnd ? (
            <InputAdornment position="end">{iconEnd}</InputAdornment>
          ) : null,
          fontSize: '10'
        }}
      />
    );
  };



  // const WhiteTextTypography = withStyles({
  //   root: {
  //     color: "#FFFFFF",
  //     fontSize: "1.5rem"
  //   }
  // })(Typography);

  // const PlatformTypography = withStyles({
  //   root: isMobile ?
  //     {
  //       fontSize: '0.5rem',
  //     }
  //     :
  //     {
  //       fontSize: '0.7rem',
  //     }
  // })(Typography);





  return (
    <div>
      <Box
      >
        <Grid
          container
          item
          xs={12} sm={12} md={12} lg={12} xl={12}
          direction="column"
          justifyContent="space-around"
          alignItems="center"
        >

          <Grid
            container
            item
            sx={{ marginBottom: "1rem" }}
            xs={12} sm={12} md={12} lg={12} xl={12}
            direction="row"
            justifyContent="flex-end"
          // alignItems="center"
          >
            <Grid
              item
              xs={isBTC === true ? 2 : 3} sm={isBTC === true ? 2 : 3} md={isBTC === true ? 2 : 3} lg={isBTC === true ? 2 : 3} xl={isBTC === true ? 2 : 3}
            >
              {isBTC === true ?
                <Typography>
                  {Guide_clover_dialog_ExchangePage_01}:
                </Typography>
                :
                isUSTD === true &&
                <Typography>
                  {Guide_clover_dialog_ExchangePage_02}:
                </Typography>
              }
            </Grid>
            <Grid
              item
              xs={isBTC === true ? 10 : 9} sm={isBTC === true ? 10 : 9} md={isBTC === true ? 10 : 9} lg={isBTC === true ? 10 : 9} xl={isBTC === true ? 10 : 9}

            >
              {isBTC === true ?
                <WalletTextField
                  disabled
                  value={BTCaddress !== undefined ? BTCaddress : ''}
                  // iconStart={<Typography>플레타:</Typography>}
                  iconEnd={<FontAwesomeIcon icon={faCopy} size={isMobile ? 'lg' : 'xl'} onClick={(e) => { copy(BTCaddress !== undefined ? BTCaddress : '') }} />}
                />
                :
                isUSTD === true &&
                <WalletTextField
                  disabled
                  value={USDTaddress !== undefined ? USDTaddress : ''}
                  // iconStart={<Typography>플레타:</Typography>}
                  iconEnd={<FontAwesomeIcon icon={faCopy} size={isMobile ? 'lg' : 'xl'} onClick={(e) => { copy(USDTaddress !== undefined ? USDTaddress : '') }} />}
                />
              }
            </Grid>
          </Grid>

          <Grid
            container
            item
            sx={{ marginBottom: "1rem" }}
            xs={12} sm={12} md={12} lg={12} xl={12}
            direction="row"
            justifyContent="flex-end"
          // alignItems="center"
          >
            <Grid
              container
              item
              xs={1} sm={1} md={1} lg={1} xl={1}
              justifyContent="flex-start"
            >
              <Typography>
                ID:
              </Typography>
            </Grid>
            <Grid
              item
              xs={11} sm={11} md={11} lg={11} xl={11}
            >
              <TextField
                variant="standard"
                // label={Guide_clover_allPage_01}
                inputProps={isMobile ? { min: 0, style: { textAlign: 'center', fontSize: 13 } } : { min: 0, style: { textAlign: 'center' } }}
                fullWidth
                value={userID}
                // placeholder={GuideWallet}
                // onClick={(e)=>{CoinStore.WalletTextclick(e)}}
                onChange={(e) => { TextData("ID", e?.target?.value) }}
              />
            </Grid>
          </Grid>


          <Grid
            container
            item
            sx={{ marginBottom: "1rem" }}
            xs={12} sm={12} md={12} lg={12} xl={12}
            direction="row"
            justifyContent="flex-end"
          // alignItems="center"
          >
            <Grid
              container
              item
              xs={2} sm={2} md={2} lg={2} xl={2}
              justifyContent="flex-start"
            >
              <Typography>
                Name:
              </Typography>
            </Grid>
            <Grid
              item
              xs={10} sm={10} md={10} lg={10} xl={10}
            >
              <TextField
                variant="standard"
                // label={Guide_clover_allPage_01}
                inputProps={isMobile ? { min: 0, style: { textAlign: 'center', fontSize: 13 } } : { min: 0, style: { textAlign: 'center' } }}
                fullWidth
                value={userName}
                // placeholder={GuideWallet}
                // onClick={(e)=>{CoinStore.WalletTextclick(e)}}
                onChange={(e) => { TextData("Name", e?.target?.value) }}
              />
            </Grid>
          </Grid>

          <Grid
            container
            item
            sx={{ marginBottom: "1rem" }}
            xs={12} sm={12} md={12} lg={12} xl={12}
            direction="row"
            justifyContent="flex-end"
          // alignItems="center"
          >
            <Grid
              container
              item
              xs={2} sm={2} md={2} lg={2} xl={2}
              justifyContent="flex-start"
            >
              <Typography>
                {Guide_clover_dialog_Mining_13}:
              </Typography>
            </Grid>
            <Grid
              item
              xs={10} sm={10} md={10} lg={10} xl={10}
            >
              <TextField
                type='number'
                variant="standard"
                // label={Guide_clover_allPage_01}
                inputProps={isMobile ? { min: 0, style: { textAlign: 'center', fontSize: 13 } } : { min: 0, style: { textAlign: 'center' } }}
                fullWidth
                value={userCountBTC}
                // placeholder={GuideWallet}
                // onClick={(e)=>{CoinStore.WalletTextclick(e)}}
                onChange={(e) => { TextData("BTC", e?.target?.value) }}
              />
            </Grid>
          </Grid>

          <Grid
            container
            item
            sx={{ marginBottom: "1rem" }}
            xs={12} sm={12} md={12} lg={12} xl={12}
            direction="row"
            justifyContent="flex-end"
          // alignItems="center"
          >
            <Grid
              container
              item
              xs={2} sm={2} md={2} lg={2} xl={2}
              justifyContent="flex-start"
            >
              <Typography>
                {Guide_clover_dialog_ExchangePage_03}:
              </Typography>
            </Grid>
            <Grid
              item
              xs={10} sm={10} md={10} lg={10} xl={10}
            >
              <TextField
                variant="standard"
                // label={Guide_clover_allPage_01}
                inputProps={isMobile ? { min: 0, style: { textAlign: 'center', fontSize: 13 } } : { min: 0, style: { textAlign: 'center' } }}
                fullWidth
                value={userBank}
                // placeholder={GuideWallet}
                // onClick={(e)=>{CoinStore.WalletTextclick(e)}}
                onChange={(e) => { TextData("은행", e?.target?.value) }}
              />
            </Grid>
          </Grid>


          <Grid
            container
            item
            sx={{ marginBottom: "1rem" }}
            xs={12} sm={12} md={12} lg={12} xl={12}
            direction="row"
            justifyContent="flex-end"
          // alignItems="center"
          >
            <Grid
              container
              item
              xs={2} sm={2} md={2} lg={2} xl={2}
              justifyContent="flex-start"
            >
              <Typography>
                {Guide_clover_dialog_ExchangePage_04}:
              </Typography>
            </Grid>
            <Grid
              item
              xs={10} sm={10} md={10} lg={10} xl={10}
            >
              <TextField
                variant="standard"
                // label={Guide_clover_allPage_01}
                inputProps={isMobile ? { min: 0, style: { textAlign: 'center', fontSize: 13 } } : { min: 0, style: { textAlign: 'center' } }}
                fullWidth
                value={userAddress}
                // placeholder={GuideWallet}
                // onClick={(e)=>{CoinStore.WalletTextclick(e)}}
                onChange={(e) => { TextData("계좌번호", e?.target?.value) }}
              />
            </Grid>
          </Grid>

          <Grid
            container
            item
            sx={{ marginTop: "1rem" }}
            xs={12} sm={12} md={12} lg={12} xl={12}
            direction="row"
            justifyContent="flex-end"
          // alignItems="center"
          >

            <Grid item xs={8} sm={8} md={8} lg={8} xl={8} />

            <Grid
              item
              xs={4} sm={4} md={4} lg={4} xl={4}
            >
              <Button onClick={() => { ButtonData("전송") }}> {Guide_clover_dialog_ExchangePage_05} </Button>
              <Button onClick={() => { loginStore.setDialogClose("CoinExchangeProposeFalse") }}> {Guide_clover_dialog_ExchangePage_06} </Button>
            </Grid>

          </Grid>



        </Grid>

      </Box>




    </div >
  );
};

export default observer(ExchangePage);


